export const normalizeCategory = (cat) => {
    if (!cat) return null;
    let clean = cat.trim();
    const lower = clean.toLowerCase();

    // Priority checks (inclusion based)

    // T-shirts and Tops (catch "t shirt", "t-shirt", "tee", etc)
    if (lower.includes('t-shirt') || lower.includes('tshirt') || lower.includes('t shirt') || lower.includes('tee') || lower.includes('tank top') || lower.includes('débardeur') || lower.includes('top') || lower === 'maillot' || lower.includes('jersey')) return 'T-Shirts & Tops';

    // Chaussures and Sneakers
    if (lower.includes('chaussure') || lower.includes('sneaker') || lower.includes('basket') || lower.includes('botte') || lower.includes('mocassin') || lower.includes('shoe')) return 'Chaussures';

    // Chaussettes (must be BEFORE Accessoires if "Accessoire, Chaussette")
    if (lower.includes('chaussette') || lower.includes('sock')) return 'Chaussettes';

    // Vestes and Manteaux
    if (lower.includes('veste') || lower.includes('manteau') || lower.includes('blouson') || lower.includes('jacket') || lower.includes('coat') || lower.includes('trench') || lower.includes('windbreaker') || lower.includes('parka')) return 'Vestes & Manteaux';

    // Pantalons, Jeans, Leggings
    if (lower.includes('pantalon') || lower.includes('jean') || lower.includes('jogger') || lower.includes('jogging') || lower.includes('legging') || lower.includes('short') || lower.includes('maillot de bain') || lower.includes('swim') || lower.includes('cycliste') || lower.includes('pants') || lower.includes('trousers') || lower.includes('chino') || lower.includes('cargo') || lower.includes('bermuda')) return 'Bas (Pantalons, Jeans, Shorts)';

    // Pulls and Sweats
    if (lower.includes('pull') || lower.includes('sweat') || lower.includes('hoodie') || lower.includes('cardigan') || lower.includes('gilet')) return 'Pulls & Sweats';

    // Chemises and Blouses
    if (lower.includes('chemise') || lower.includes('shirt') || lower.includes('blouse')) return 'Chemises';

    // Sacs (CHECK BEFORE ACCESSOIRES - "Sac, Accessoire" -> Sac)
    if (lower.includes('sac') || lower.includes('bag') || lower.includes('totebag') || lower.includes('banane') || lower.includes('pochette') || lower.includes('porte-monnaie') || lower.includes('portefeuille') || lower.includes('etui')) return 'Sacs & Petite Maroquinerie';

    // Chapeaux and Bonnets (CHECK BEFORE ACCESSOIRES - "Chapeau, Accessoire" -> Chapeau)
    if (lower.includes('chapeau') || lower.includes('bonnet') || lower.includes('casquette') || lower.includes('bob') || lower.includes('balaclava') || lower.includes('cagoule') || lower.includes('beanie')) return 'Chapeaux & Bonnets';

    // Sous-vêtements
    if (lower.includes('boxer') || lower.includes('caleçon') || lower.includes('slip') || lower.includes('culotte') || lower.includes('soutien-gorge') || lower.includes('underwear')) return 'Sous-vêtements';

    // Accessoires (Fallback for generic accessories or combinations ending in Accessoire)
    if (lower.includes('accessoire') || lower.includes('bijou') || lower.includes('ceinture') || lower.includes('gant') || lower.includes('écharpe') || lower.includes('foulard') || lower.includes('lunettes') || lower.includes('tapis')) return 'Accessoires';

    // Capitalize first letter for others
    return clean.charAt(0).toUpperCase() + clean.slice(1);
};
